// @ts-nocheck
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const tag: Styleguide["tag"] = {
    defaultProps: {
        color: "info.alt",
        typographyProps: {
            color: "primary",
            // size: TYPOGRAPHY.size.smaller,
        },
        iconProps: {
            size: 20,
            color: "primary",
        },
        css: css`
            display: flex;
            align-items: center;
            padding: 0.3em 0.5em 0.3em 0.75em;
            border-radius: 1em;
            margin: 0 ${pxToRem(10)} ${pxToRem(13)} 0;

            button {
                min-width: 0;
                min-height: 0;
                ${transitionHoverStyles()}

                &:hover {
                    background-color: transparent;

                    * {
                        color: ${getColor("info.main")};
                    }
                }
            }
        `,
    },
};

export default tag;
